<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol lg="3">
                <CInput
                  disabled
                  label="User"
                  invalid-feedback="User name should be filled"
                  required
                  v-model="$v.complaintForm.user_code.$model"
                  :is-valid="!$v.complaintForm.user_code.$invalid"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Complaint Type"
                  invalid-feedback="Name should be filled"
                  required
                  v-model="$v.complaintForm.complaint_type.$model"
                  :is-valid="!$v.complaintForm.complaint_type.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Order Number"
                  invalid-feedback="Order number should be filled"
                  required
                  v-model="$v.complaintForm.order_number.$model"
                  :is-valid="!$v.complaintForm.order_number.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Date Inserted"
                  invalid-feedback="Order number should be filled"
                  required
                  v-model="complaintForm.date_inserted"
                  :is-valid="!$v.complaintForm.order_number.$invalid"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="user_code">Status</label>
                  <model-select
                    class="form-control"
                    id="user_code"
                    :options="complaintStatusList"
                    v-model="$v.complaintForm.status.$model"
                    :isError="$v.complaintForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.complaintForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >Status should be filled.</div>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.complaintForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Response</template>
            <br />
            <RespondChat
              :complaints="complaintForm"
              :complaintData="complaintdetail"
            ></RespondChat>

            <!-- <RespondList
              :complaints="complaintForm"
              :complaintData="complaintdetail"
            ></RespondList> -->
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";
import { required } from "vuelidate/lib/validators";
import RespondList from "./tabs/RespondList";
import RespondChat from "./tabs/RespondChat";

export default {
  name: "ComplaintDetails",
  components: { GlobalTable, Loading, RespondList, RespondChat},
  data() {
    return {
      title: "Complaint Detail",
      items: [],
      complaintdetail: [],
      complaintStatusList: [],
      complaintForm: tableInterfaces.complaint,
      complaintDetailForm: tableInterfaces.complaint_detail,
      isLoading: false,
      activeTab: 0,
    };
  },
  validations: {
    complaintForm: {
      complaint_type: {  },
      order_number: {  },
      user_code: {  },
      status: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailIssue(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/complaint/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.complaintForm = response.data.data;
            this.complaintForm.user_code = response.data.data.user_name;
            this.complaintdetail = response.data.dataDetail;
            this.complaintStatusList = response.data.complaint_status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/complaint/update-status", this.complaintForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Complaint Update Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Complaint Update Status");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);

    this.loadingRooms = false
    this.messagesLoaded = true
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
